import { hideVisually } from 'polished'
import React, { Fragment, HTMLAttributes } from 'react'

import theme from 'theme'

const radioSize = 24
const radioDotSize = 10

export const RadioButton: React.FC<
  HTMLAttributes<HTMLInputElement> & {
    checked: boolean
    disabled: boolean
    id: string
  }
> = ({ checked, disabled, id, ...rest }) => {
  return (
    <Fragment>
      <input
        data-test-radio-button-input
        checked={checked}
        css={{
          ...hideVisually(),

          '&:checked + div': {
            backgroundColor: theme.colors.blue[0],
            borderColor: theme.colors.blue[0],
            transition: '150ms background-color, 150ms border-color',

            '&::after': {
              opacity: 1
            }
          }
        }}
        id={String(id)}
        type="radio"
        {...rest}
      />
      <div
        css={{
          height: radioSize,
          width: radioSize,
          cursor: disabled ? 'not-allowed' : 'pointer',
          border: '1px solid',
          borderColor: theme.colors.border[0],
          borderRadius: theme.borderRadius[2],
          backgroundColor: theme.colors.grayOverlay[0],
          position: 'relative',
          flex: 'none',

          '&::after': {
            content: "''",
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            height: radioDotSize,
            width: radioDotSize,
            backgroundColor: 'white',
            borderRadius: theme.borderRadius[2],
            border: '1px solid',
            borderColor: theme.colors.blue[0],
            opacity: 0,
            transition: '150ms opacity'
          }
        }}
      />
    </Fragment>
  )
}
